import { CountryAlertType, CountryRiskField, CountryRiskRole } from './types';

const { HardStop, ComplianceReview } = CountryAlertType;

/**
 * Alert type shown next to a Prohibited country, by role and field.
 * A field missing for the role gets no country badges at all.
 */
export const countryAlertTypes: Record<
  CountryRiskRole,
  Partial<Record<CountryRiskField, CountryAlertType>>
> = {
  [CountryRiskRole.Client]: {
    [CountryRiskField.Citizenship]: HardStop,
    [CountryRiskField.TaxResidence]: HardStop,
    [CountryRiskField.PlaceOfBirth]: ComplianceReview,
    [CountryRiskField.ResidentialAddress]: HardStop,
    [CountryRiskField.RegistrationAddress]: HardStop,
    [CountryRiskField.IdentityDocument]: HardStop,
    [CountryRiskField.WithdrawalAccountBankCountry]: HardStop,
  },
  [CountryRiskRole.ClientRepresentative]: {
    [CountryRiskField.Citizenship]: HardStop,
    [CountryRiskField.TaxResidence]: HardStop,
    [CountryRiskField.PlaceOfBirth]: ComplianceReview,
    [CountryRiskField.ResidentialAddress]: HardStop,
    [CountryRiskField.RegistrationAddress]: HardStop,
    [CountryRiskField.IdentityDocument]: HardStop,
  },
  [CountryRiskRole.LegalClient]: {
    [CountryRiskField.CompanyTaxResidence]: HardStop,
    [CountryRiskField.CompanyRegistrationPlace]: HardStop,
    [CountryRiskField.CompanyLegalAddress]: HardStop,
    [CountryRiskField.CompanyActualAddress]: HardStop,
    [CountryRiskField.WithdrawalAccountBankCountry]: HardStop,
  },
  [CountryRiskRole.LegalClientRepresentative]: {
    [CountryRiskField.Citizenship]: HardStop,
    [CountryRiskField.TaxResidence]: HardStop,
    [CountryRiskField.PlaceOfBirth]: ComplianceReview,
    [CountryRiskField.ResidentialAddress]: HardStop,
    [CountryRiskField.RegistrationAddress]: HardStop,
    [CountryRiskField.IdentityDocument]: HardStop,
    // Company of the representative
    [CountryRiskField.CompanyTaxResidence]: HardStop,
    [CountryRiskField.CompanyLegalAddress]: HardStop,
    [CountryRiskField.CompanyActualAddress]: HardStop,
  },
  [CountryRiskRole.LegalClientHead]: {
    [CountryRiskField.Citizenship]: HardStop,
    [CountryRiskField.TaxResidence]: HardStop,
    [CountryRiskField.PlaceOfBirth]: ComplianceReview,
    [CountryRiskField.ResidentialAddress]: HardStop,
    [CountryRiskField.RegistrationAddress]: HardStop,
    [CountryRiskField.IdentityDocument]: HardStop,
  },
  [CountryRiskRole.LegalClientLegalHead]: {
    [CountryRiskField.CompanyTaxResidence]: HardStop,
    [CountryRiskField.CompanyLegalAddress]: HardStop,
    [CountryRiskField.CompanyActualAddress]: HardStop,
  },
  [CountryRiskRole.LegalClientFirstHead]: {
    [CountryRiskField.Citizenship]: ComplianceReview,
    [CountryRiskField.TaxResidence]: ComplianceReview,
    [CountryRiskField.PlaceOfBirth]: ComplianceReview,
    [CountryRiskField.ResidentialAddress]: ComplianceReview,
    [CountryRiskField.RegistrationAddress]: ComplianceReview,
    [CountryRiskField.IdentityDocument]: ComplianceReview,
  },
  [CountryRiskRole.LegalClientBeneficiary]: {
    [CountryRiskField.Citizenship]: HardStop,
    [CountryRiskField.TaxResidence]: HardStop,
    [CountryRiskField.PlaceOfBirth]: ComplianceReview,
    [CountryRiskField.ResidentialAddress]: HardStop,
    [CountryRiskField.RegistrationAddress]: HardStop,
    [CountryRiskField.IdentityDocument]: HardStop,
  },
};
